export default "/_next/static/images/img4-4a039c22c39b73aa15433762d18ae1eb.png";